import { useContext, createContext } from 'react';

interface ContextValue {
    desktop: boolean;
    mobile: boolean;
}

const MediaContext = createContext({
    desktop: false,
    mobile: false,
});

export const useMediaContext = (): ContextValue => useContext(MediaContext);

export const MediaContextProvider = MediaContext.Provider;
